
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locationSlug]/[merchantSlug]/[merchantId]/account",
      function () {
        return require("private-next-pages/[locationSlug]/[merchantSlug]/[merchantId]/account/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locationSlug]/[merchantSlug]/[merchantId]/account"])
      });
    }
  